var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{staticClass:"mb-4",attrs:{"title":_vm.$trans(_vm.section.name)}},[_c('div',{staticClass:"row"},_vm._l((_vm.rows),function(row){return _c('form-row',{key:'row-'+row.id,attrs:{"row":row}})}),1),_vm._v(" "),_vm._l((_vm.sections),function(section){return _c('form-section',{key:'section-'+section.id,attrs:{"section":section}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }